export const ME = '/api/v1/user/me';
export const USER = '/api/v1/user';
export const VACCINATION = '/api/v1/vaccination';
export const VACCINATION_OFFICE_NUMBER = officeNumber =>
  `/api/v1/vaccination/vaccinationOfficeNumber/${officeNumber}`;
export const REPORT_VACCINATION = '/api/v1/vaccination/vaccinationOfficeNumber';
